export default "https://cdn-static.gokick.com/assets/9d5d62c9c10b295872f7f6ffd14ff177054c61a9/images/spearmint-flavor.30903ab4672f84579e06d9b02d9a9cc8.png";